import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { RetryHttpClient } from "../services/base/retryable-http.client";

export class RegionalTranslateLoader implements TranslateLoader {
  private baseUrl = "./assets/i18n/";

  constructor(private http: RetryHttpClient) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    const path = this.getPathForLanguage(lang);
    return this.http.get<Record<string, unknown>>(path);
  }

  private getPathForLanguage(lang: string): string {
    let subfolder = "";
    const suffix = ".json";

    switch (lang) {
      case "es-cl":
      case "es-co":
      case "es-pe":
        subfolder = "latam/";
        break;
      case "es-es":
        subfolder = "europe/";
        break;
      default:
        console.warn(`No regional folder configured for language: ${lang}. Trying base path.`);
        subfolder = "";
        break;
    }
    return `${this.baseUrl}${subfolder}${lang}${suffix}`;
  }
}
